// @flow
import React from 'react';
import LegacyDispatcher from 'app/lib/legacyDispatcher';
import JobLogLineStore from 'app/stores/JobLogLineStore';

type Props = {
  id: string,
  number: number,
  line: string
};

type State = {
  highlighted: boolean
};

const getStateFromStores = (id): State => ({ highlighted: JobLogLineStore.isHighlighted(id) });

export default class JobLogOutputLine extends React.PureComponent<Props, State> {
  wrapperNode: ?HTMLTableRowElement;

  constructor(props: Props) {
    super(props);

    this.state = getStateFromStores(props.id);
  }

  componentDidMount() {
    JobLogLineStore.addChangeListener(this.props.id, this.handleLineStoreChange);
    this.emitHighlighted();
  }

  componentWillUnmount() {
    JobLogLineStore.removeChangeListener(this.props.id, this.handleLineStoreChange);
  }

  componentDidUpdate() {
    this.emitHighlighted();
  }

  // Notify the stores that a highlighted line has been rendered. This gives the
  // stores an opportunity to scroll to this line if they need to.
  emitHighlighted() {
    if (this.state.highlighted) {
      return LegacyDispatcher.emit("job_log_line:highlighted", {
        lineId: this.props.id,
        el: this.wrapperNode
      });
    }
  }

  handleLineStoreChange = () => {
    return this.setState(getStateFromStores(this.props.id));
  };

  handleNumberClick = (evt: MouseEvent) => {
    evt.preventDefault();

    return LegacyDispatcher.emit("job_log_line:highlight", {
      lineId: this.props.id
    });
  };

  render() {
    const className = (
      this.state.highlighted
        ? "JobLogOutputComponent__Line--Highlighted"
        : "JobLogOutputComponent__Line"
    );

    return (
      <tr
        ref={(wrapperNode) => this.wrapperNode = wrapperNode}
        className={className}
      >
        <td
          className="JobLogOutputComponent__Number"
          onClick={this.handleNumberClick}
          data-line-number={this.props.number}
        />
        <td
          className="JobLogOutputComponent__Line__Content"
          colSpan="2"
          dangerouslySetInnerHTML={{ __html: this.props.line }}
        />
      </tr>
    );
  }
}
